import Menu from './Compartido/Menu.jsx';
import TextoLegal from './Legal/TextoLegal.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Legal = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Aviso-Legal"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextoLegal
                lang={props.lang}
                legal={props.textoavisolegal}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Legal;

